import { Button } from "primereact/button";

import styles from "../../filter-panel.module.scss";
import { FilterPanelAddButton } from "../add-button";
import type { FilterPanelMobileActionsViewProps } from "./types-mobile-actions";

export function FilterPanelMobileActionsView({ clearButton }: FilterPanelMobileActionsViewProps) {
  return (
    <div className={styles.mobileActions}>
      <FilterPanelAddButton />
      {clearButton ? (
        <Button
          type="button"
          className={clearButton.className}
          icon={clearButton.icon}
          label={clearButton.label}
          text
          severity="secondary"
          disabled={clearButton.disabled}
          onClick={clearButton.onClick}
          data-testid={clearButton.testId}
        />
      ) : null}
    </div>
  );
}
